// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2WGch","header":"MergedInvoice_header__2G7hN"};